import { render, staticRenderFns } from "./WorkflowDetailStatusTargetStatuses.vue?vue&type=template&id=10531d90"
import script from "./WorkflowDetailStatusTargetStatuses.vue?vue&type=script&lang=js"
export * from "./WorkflowDetailStatusTargetStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports